import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function LoginPage() {
  const { signIn, signUp } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [role, setRole] = useState<'admin' | 'student'>('student');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setLoading(true);
    const { error: err } = await signIn(email, password);
    setLoading(false);
    if (err) { setError('이메일 또는 비밀번호를 확인해주세요.'); return; }
    navigate('/mode-select');
  };

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(''); setLoading(true);
    if (password.length < 6) { setError('비밀번호는 6자 이상이어야 합니다.'); setLoading(false); return; }
    const { error: err } = await signUp(email, password, displayName, role);
    setLoading(false);
    if (err) { setError(err); return; }
    setSuccess('가입 완료! 로그인해주세요.');
    setTab('login');
  };

  return (
    <div className="min-h-screen bg-[#0C0C0E] flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        {/* 홈으로 링크 */}
        <div className="mb-6">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="flex items-center gap-1.5 text-[#3D3D3D] hover:text-[#888888] text-xs transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-sm"></i>홈으로
          </button>
        </div>
        {/* Logo */}
        <div className="flex items-center justify-center gap-2.5 mb-10">
          <img src="https://storage.readdy-site.link/project_files/e81f0f74-7f28-46c8-8485-3df778381a50/9a17726c-ea2b-4ef1-b154-44e1a8dd8821_Gemini_Generated_Image_at6qf4at6qf4at6q-removebg-preview.png?v=7e9fc5a9989fd2f2c3e90b758ae037ba" alt="K-ArtPEN" className="w-10 h-10 object-contain" />
          <div>
            <div className="text-[#F2F2F2] font-semibold text-sm tracking-wide">K-ArtPEN</div>
            <div className="text-[#3D3D3D] text-[9px] tracking-widest uppercase">Virtual Ent. Platform</div>
          </div>
        </div>

        {/* Tab */}
        <div className="flex gap-0.5 mb-6 bg-white/[0.03] border border-white/[0.05] rounded-lg p-0.5">
          {(['login', 'register'] as const).map(t => (
            <button key={t} type="button" onClick={() => setTab(t)}
              className={`flex-1 py-2 rounded-md text-xs font-medium transition-all whitespace-nowrap cursor-pointer ${tab === t ? 'bg-[#4B6CF7]/20 text-[#7A9BFF] border border-[#4B6CF7]/20' : 'text-[#444444] hover:text-[#777777]'}`}>
              {t === 'login' ? '로그인' : '회원가입'}
            </button>
          ))}
        </div>

        {/* Feedback */}
        {success && <div className="mb-4 px-3 py-2.5 bg-white/[0.04] border border-white/[0.08] rounded-lg text-[#AAAAAA] text-xs">{success}</div>}
        {error && <div className="mb-4 px-3 py-2.5 bg-white/[0.03] border border-white/[0.06] rounded-lg text-[#888888] text-xs">{error}</div>}

        {tab === 'login' ? (
          <form onSubmit={handleLogin} className="space-y-3">
            <div>
              <label className="text-[#444444] text-[11px] mb-1.5 block">이메일</label>
              <input type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="example@email.com"
                className="w-full bg-white/[0.02] border border-white/[0.07] rounded-lg px-3 py-2.5 text-[#F2F2F2] text-sm placeholder-[#2A2A2A] focus:outline-none focus:border-white/20 transition-colors" />
            </div>
            <div>
              <label className="text-[#444444] text-[11px] mb-1.5 block">비밀번호</label>
              <input type="password" name="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••"
                className="w-full bg-white/[0.02] border border-white/[0.07] rounded-lg px-3 py-2.5 text-[#F2F2F2] text-sm placeholder-[#2A2A2A] focus:outline-none focus:border-white/20 transition-colors" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#4B6CF7] text-white py-2.5 rounded-lg font-semibold text-sm hover:bg-[#5B7CF7] transition-colors disabled:opacity-40 whitespace-nowrap cursor-pointer mt-1">
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleRegister} className="space-y-3">
            <div>
              <label className="text-[#444444] text-[11px] mb-1.5 block">이름</label>
              <input type="text" value={displayName} onChange={e => setDisplayName(e.target.value)} required placeholder="홍길동"
                className="w-full bg-white/[0.02] border border-white/[0.07] rounded-lg px-3 py-2.5 text-[#F2F2F2] text-sm placeholder-[#2A2A2A] focus:outline-none focus:border-white/20 transition-colors" />
            </div>
            <div>
              <label className="text-[#444444] text-[11px] mb-1.5 block">이메일</label>
              <input type="email" name="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="example@email.com"
                className="w-full bg-white/[0.02] border border-white/[0.07] rounded-lg px-3 py-2.5 text-[#F2F2F2] text-sm placeholder-[#2A2A2A] focus:outline-none focus:border-white/20 transition-colors" />
            </div>
            <div>
              <label className="text-[#444444] text-[11px] mb-1.5 block">비밀번호</label>
              <input type="password" name="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="6자 이상"
                className="w-full bg-white/[0.02] border border-white/[0.07] rounded-lg px-3 py-2.5 text-[#F2F2F2] text-sm placeholder-[#2A2A2A] focus:outline-none focus:border-white/20 transition-colors" />
            </div>
            <div>
              <label className="text-[#444444] text-[11px] mb-1.5 block">역할</label>
              <div className="grid grid-cols-2 gap-1.5">
                {(['student', 'admin'] as const).map(r => (
                  <button key={r} type="button" onClick={() => setRole(r)}
                    className={`py-2 rounded-lg text-xs font-medium border transition-all whitespace-nowrap cursor-pointer ${role === r ? 'border-white/20 bg-white/[0.07] text-[#F2F2F2]' : 'border-white/[0.05] text-[#444444] hover:border-white/10'}`}>
                    {r === 'student' ? '학생' : '강사'}
                  </button>
                ))}
              </div>
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#4B6CF7] text-white py-2.5 rounded-lg font-semibold text-sm hover:bg-[#5B7CF7] transition-colors disabled:opacity-40 whitespace-nowrap cursor-pointer">
              {loading ? '가입 중...' : '회원가입'}
            </button>
          </form>
        )}

        <p className="text-center text-[#2A2A2A] text-[10px] mt-6">K-ArtPEN 가상 엔터테인먼트 시뮬레이션</p>
      </div>
    </div>
  );
}
